import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledPath = styled.path`
  ${({ pFill, theme }) =>
    `fill: ${typeof pFill === 'function' ? pFill(theme) : pFill}`}
`;

const IconUser = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 35"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
    >
      <StyledPath
        d="M17.14608,4.36983782e-13 C26.6155917,4.36983782e-13 34.29216,7.67656829 34.29216,17.14608 C34.29216,26.6155987 26.6155917,34.29216 17.14608,34.29216 C7.67656129,34.29216 -1.77635684e-14,26.6155987 -1.77635684e-14,17.14608 C-1.77635684e-14,7.67656829 7.67656129,4.36983782e-13 17.14608,4.36983782e-13 Z M22.1116081,20.8702296 L12.1805496,20.8702296 C8.79167235,20.8702296 6.02340157,23.615254 5.97840186,26.9949143 C8.70626621,30.0859373 12.6882252,32.0426736 17.14608,32.0426736 C21.6039348,32.0426736 25.5858238,30.0859373 28.3137535,26.9949143 C28.2688704,23.615254 25.50056,20.8702296 22.1116081,20.8702296 Z M17.14608,5.97362429 C13.7322581,5.97362429 10.9391664,8.76673238 10.9391664,12.1805519 C10.9391664,15.5943714 13.7322581,18.3874632 17.14608,18.3874632 C20.5599019,18.3874632 23.3529843,15.5943714 23.3529843,12.1805519 C23.3529843,8.76673238 20.5599019,5.97362429 17.14608,5.97362429 Z"
        pFill={fill}
      />
    </svg>
  );
};

IconUser.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

IconUser.defaultProps = {
  width: '34',
  height: '34',
  fill: 'white',
};

export default IconUser;
